import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectsCalcViewComponent} from './projects-calc-view/projects-calc-view.component';
import {ProjectCalcDetailViewComponent} from './projects-calc-view/project-calc-detail-view/project-calc-detail-view.component';
import {ProjectCalcRoutingModule} from 'projects/app-misc/src/app/modules/project-calc/data/project-calc-routing.module';
import {MatButtonModule} from '@angular/material/button';
import {ProjectAreaViewComponent} from './projects-calc-view/project-calc-detail-view/project-area-view/project-area-view.component';
import {TableSheetComponent} from './table-sheet/table-sheet.component';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {MiscModule} from '../../../../../core/src/lib/misc/misc.module';
import {PaginatorModule} from 'primeng/paginator';
import {InputTextModule} from 'primeng/inputtext';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MultiSelectModule} from 'primeng/multiselect';
import {ProposalPdfDialogComponent} from './proposal-pdf-dialog/proposal-pdf-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {CheckboxModule} from 'primeng/checkbox';
import {AutoCompleteModule} from "primeng/autocomplete";
import { SettingsTableSheetComponent } from './table-sheet/settings-table-sheet/settings-table-sheet.component';
import { SubtotalsTableSheetComponent } from './table-sheet/subtotals-table-sheet/subtotals-table-sheet.component';
import { BreakdownTableSheetComponent } from './table-sheet/breakdown-table-sheet/breakdown-table-sheet.component';
import { FormulasTableSheetComponent } from './table-sheet/formulas-table-sheet/formulas-table-sheet.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';


@NgModule({
  declarations: [
    ProjectsCalcViewComponent,
    ProjectCalcDetailViewComponent,
    ProjectAreaViewComponent,
    TableSheetComponent,
    ProposalPdfDialogComponent,
    SettingsTableSheetComponent,
    SubtotalsTableSheetComponent,
    BreakdownTableSheetComponent,
    FormulasTableSheetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MiscModule,
    ProjectCalcRoutingModule,
    MatButtonModule,
    DropdownModule,
    MultiSelectModule,
    PaginatorModule,
    InputTextModule,
    ConfirmDialogModule,
    MatIconModule,
    NgxExtendedPdfViewerModule,
    MatDialogModule,
    MatRippleModule,
    CheckboxModule,
    AutoCompleteModule,
    MatProgressBarModule
  ]
})
export class ProjectCalcModule {
}
